'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EXPIRES_AT = exports.EXPIRES_AT = ['expiresAt'];

var URL = exports.URL = ['url'];

var NAME = exports.NAME = ['name'];

var EXTENSION = exports.EXTENSION = ['extension'];

var TYPE = exports.TYPE = ['type'];

var SIZE = exports.SIZE = ['fileSize'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/file-metadata/constants/fileMetadataKeyPaths.js
// module id = 1120
// module chunks = 2 3